import { defineComponent } from 'vue';
import type { INotificationModalResource } from '@rready/sdk';

export type ModalType = 'basic' | 'review';

export const ModalOpenEventName = 'modalOpenEvent';
export const ModalCloseEventName = 'modalCloseEvent';

export const modalCaptureMixin = defineComponent({
  data() {
    return {
      modalType: undefined as ModalType | undefined,
      modalContent: undefined as INotificationModalResource | undefined
    };
  },
  computed: {
    modalOpened(): boolean {
      return !!this.modalType && !!this.modalContent;
    }
  },
  mounted() {
    this.$el.addEventListener(ModalOpenEventName, (e: any) => {
      e.stopPropagation();

      const modalType: ModalType = e.detail?.type;
      const modalContent: INotificationModalResource = e.detail?.content;

      if (!modalType || !modalContent) {
        console.warn('Could not display empty toast message');
        this.modalType = undefined;
        this.modalContent = undefined;
        return;
      }

      this.modalType = modalType;
      this.modalContent = modalContent;
    });

    this.$el.addEventListener(ModalCloseEventName, (e: any) => {
      e.stopPropagation();
      this.modalType = undefined;
      this.modalContent = undefined;
    });
  }
});
